export default __webpack_public_path__ + "static/media/s6.7be882b3.png";